import type { BlogPostSummary } from "@/content/blog";
import { formatBlogDate } from "@/app/features/blog/functions/formatBlogDate";

export type PostBylineProps = {
  post: BlogPostSummary;
  /** Adds the last-updated date, when the article has one of its own. */
  showUpdated?: boolean;
};

/**
 * A post's date and reading time as one run of words, for a card's meta line
 * or an article's header. Inline content only, so it can sit inside a
 * paragraph. An idea or draft has no date to show yet.
 */
export function PostByline({ post, showUpdated = false }: PostBylineProps) {
  const dated = post.status === "ready" || post.status === "published";
  const updated =
    showUpdated && post.updatedAt && post.updatedAt !== post.publishedAt
      ? post.updatedAt
      : undefined;

  return (
    <>
      {dated && (
        <>
          <time dateTime={post.publishedAt}>
            {formatBlogDate(post.publishedAt)}
          </time>
          {" · "}
        </>
      )}
      {dated && updated && <>Last updated {formatBlogDate(updated)} · </>}
      {post.readingTime}
    </>
  );
}
